
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '@shared/components/forms/inputs/field-wrapper/field-wrapper.vue';
import { mixins } from 'vue-class-component';
import AbstractField from '@shared/components/forms/inputs/abstract-field/abstract-field';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { AccessControlSale } from '@accounting/interfaces/access-control';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import { accessControlSaleFields } from '@/config/access_control_options';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import DatetimePickertpicker from '@shared/components/forms/inputs/datetimepicker/datetimepicker.vue';

@Component({
  name: 'bpc-access-control-sale-overview',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-input': Input,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-datetimepicker': DatetimePickertpicker,
  },
})
export default class AccessControlSaleOverview extends mixins(AbstractField) {
  @Prop({
    type: String,
    required: true,
  })
  readonly productType: string;
  // @Prop() readonly productId: number;
  @Prop({ type: Object }) declare readonly formModel;

  public observableSale = null;
  public observableSync = null;
  public loading: boolean = false;
  public synchronizing: boolean = false;
  public sale: AccessControlSale = null;

  mounted() {
    this.fetchSale();
  }

  private fetchSale() {
    const productId = this.formModel.id;
    if (!productId) {
      return;
    }

    this.loading = true;
    const path = `${this.$bpcApiRouteHelper.getApiPath(
      'access-control-sales/' + this.productType + '/' + productId,
    )}`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(path);
    if (this.observableSale) {
      this.observableSale.unsubscribe();
    }
    this.observableSale = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.sale = res.data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        if (error.response?.status === 404) {
          this.sale = null;
        } else {
          this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_form_action' });
        }
      },
    );
  }

  private synchronizeNow() {
    const productId = this.formModel.id;
    if (!productId) {
      return;
    }
    this.synchronizing = true;
    const path = `${this.$bpcApiRouteHelper.getApiPath(
      'access-control-sales/' + this.productType + '/' + productId + '/synchronize',
    )}`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(path);
    if (this.observableSync) {
      this.observableSync.unsubscribe();
    }
    this.observableSync = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.synchronizing = false;
        this.fetchSale();
      },
      error => {
        console.log('Sync error : ' + error);
        this.synchronizing = false;
      },
    );
  }

  get formattedLastSyncAt() {
    return this.sale?.lastSyncAt
      ? this.$bpcHelper.formatDateToTimezone(this.sale?.lastSyncAt)
      : null;
  }

  get fieldsConfig() {
    return accessControlSaleFields;
  }

  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2 mb-2': true,
        },
      },
    };
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2 mb-2': true,
        },
      },
    };
  }

  get col11() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-11 pl-2 mb-2': true,
        },
      },
    };
  }

  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2 mb-2': true,
        },
      },
    };
  }
}
